const getDisabledStatus = (rootState) => rootState.ws.view.status.disabled;

export default getDisabledStatus;
